import { Box, Grid, Typography, useTheme } from "@mui/material";
import Boxoutline from "../../../../../media/images/icons/outline-box";
import { IMessage } from "../../../../../types/notif";
import { convertToJalali } from "../../../../../utils/functions";

export default function NotifCard(props: IMessage) {
  const { insertDate, text, title } = props;
  const theme = useTheme();

  return (
    <Box>
      <Grid
        container
        sx={{
          backgroundColor: "bgColor.white",
          // border: "1px solid gray",
          padding: "4px",
          borderRadius: "8px",
          boxShadow: "2px 4px 4px 2px rgba(0, 0, 0, 0.10)",
        }}
        spacing={1}
      >
        <Grid
          item
          sx={{
            padding: "4px",
          }}
          xs={2}
        >
          <Box
            sx={{
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: theme.palette.bgColor.blueGrey50,
              paddingY: "12px",
            }}
          >
            <Boxoutline size={28} color={theme.palette.primary.main} />
          </Box>
        </Grid>
        <Grid item xs={10}>
          <Box
            sx={{
              // border: "1px solid gray",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                  fontWeight: "600",
                }}
              >
                عنوان:
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                }}
              >
                {title}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                fontSize: "14px",
              }}
            >
              {convertToJalali(insertDate).split(" ")[1]}
            </Box>
          </Box>
        </Grid>
        <Box
          sx={{
            flex: "1",
            borderRadius: "8px",
            backgroundColor: "bgColor.grey100",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
            padding: "8px 6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              متن پیام:
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            {text}
          </Typography>
        </Box>
      </Grid>
    </Box>
  );
}
